<template>
  <div style="z-index:99999;"></div>
</template>

<script>
import { mapGetters } from 'vuex'
import sdgWheels from './sdg-wheels'

export default {
  name: 'sdg-wheel',
  props: {
    view: {
      type: String
    },
    selectedTargetToWheel: {
      type: Date
    }
  },
  data () {
    return {
      jsWheel: null,
      iconsPath: []
    }
  },
  computed: {
    ...mapGetters({
      getSelectedScenario: 'getSelectedScenario',
      getProject: 'getProject',
      getWheelVisible: 'getWheelVisible',
      getIconsPath: 'getIconsPath',
      getIconsSelected: 'getIconsSelected'
    })
  },
  methods: {
    createSvg () {
      this.$el.innerHTML = ''
      let resultData = JSON.parse(JSON.stringify(this.getSelectedScenario.goals))
      resultData = resultData.filter(goal => goal.selected)

      for (let i = resultData.length - 1; i >= 0; i--) {
        if (resultData[i].targets.filter(target => target.selected).length > 0) {
          resultData[i].targets = resultData[i].targets.filter(target => target.selected)
          resultData[i].targets.forEach(target => {
            if (!target.action || !target.indicator) {
              target.disabled = true
            }
          })
        } else {
          resultData.splice(i, 1)
        }
      }

      this.jsWheel = new sdgWheels.Result(resultData, { icons: this.getIconsPath })
      this.$el.appendChild(this.jsWheel.getSvg())
    }
  },
  watch: {
    getIconsSelected (val, oldVal) {
      if (val !== oldVal) {
        this.$nextTick(() => {
        })
      }
    },
    selectedTargetToWheel (val, oldVal) {
      this.createSvg()
    }
  },
  mounted () {
    this.createSvg()
  }
}
</script>

<style lang="scss">
  .nsdg-nav-wheel {
    height: 100%;
  }
</style>
